










































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { EmploymentAndIncome } from '@/store/consumer-application/types';
import { requiredRule, incomeCharacterCountRule } from '@/form-rules';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';


@Component
export default class EmploymentAndIncomeFields extends Vue {
	employmentAndIncome: EmploymentAndIncome = {
		primaryOccupation: '',
		primarySourceOfIncome: '',
		totalAnnualIncome: '',
	};

	currency = createNumberMask({
		prefix: '$',
		allowDecimal: false,
		includeThousandsSeparator: true,
		allowNegative: false,
	});

	primaryOccupationTypes = [{text: 'Agriculture', value: 'agriculture'}, {text: 'Clergy/Ministry Staff', value: 'clergy_ministry_staff'}, 
							{text: 'Construction/Industrial', value: 'construction_industrial'}, {text: 'Education', value: 'education'}, 
							{text: 'Finance/Accounting/Tax', value: 'finance_accounting_tax'}, {text: 'Fire/First Responders', value: 'fire_first_responders'},
							{text: 'Healthcare', value: 'healthcare'}, {text: 'Labor: General', value: 'labor_general'},
							{text: 'Labor: Skilled', value: 'labor_skilled'}, {text: 'Law Enforcement/Security', value: 'law_enforcement_security'},
							{text: 'Legal Services', value: 'legal_services'}, {text: 'Military', value: 'military'},
							{text: 'Notary/Registrar', value: 'notary_registrar'}, {text: 'Private Investor', value: 'private_investor'}, 
							{text: 'Professional: Administrative', value: 'professional_administrative'},  {text: 'Professional: Management', value: 'professional_management'},
							{text: 'Professional: Other', value: 'professional_other'}, {text: 'Professional: Technical', value: 'professional_technical'},
							{text: 'Rentier', value: 'rentier'}, {text: 'Retired', value: 'retired'},
							{text: 'Sales', value: 'sales'}, {text: 'Self-Employed', value: 'self_employed'},
							{text: 'Student', value: 'student'}, {text: 'Transportation', value: 'transportation'},
							{text: 'Unemployed', value: 'unemployed'}];

	primarySourceOfIncomeTypes = [{text: 'Employment Income', value: 'salary'}, {text: 'Inheritance', value: 'inheritance'}, 
								{text: 'Life Insurance', value: 'life_insurance'}, {text: 'Sale of Company', value: 'sale_of_a_company'}, 
								{text: 'Sale of Investments', value: 'investments'}, {text: 'Sale of Property', value: 'sale_of_a_property'},
								{text: 'Other', value: 'other'}];

	data() {
		return {
			primaryOccupationRules: [
				requiredRule('Primary Occupation is required'),
			],
			primarySourceOfIncomeRules: [
				requiredRule('Primary Source of Income is required'),
			],
			totalAnnualIncomeRules: [
				requiredRule('Total Annual Income is required'),
				incomeCharacterCountRule('Total Annual Income', 9),
			]
		};
	}
	updateEmploymentAndIncome () {
		this.$store.commit('consumerApplication/SET_EMPLOYMENT_AND_INCOME_FIELDS', this.employmentAndIncome, { root: true });
	}
}
